import view from "../../views/serverview";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler } from "../classes/index.classes";


let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

let scoreBoardA = null;
let scoreBoardB = null;


let match = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {    
                     
        //console.log(data);


        
        if(!_user.authed)
        {  

        }
        else
        {            
            

        }

        renderLobby(data);

        KTScroll.init();

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};


$(document).ready(function(){    
    $(document).on("click", "#lobby-share-url",async function() {   
        $("#lobby-btn-share").trigger("click");
    });

    $(document).on("click", ".lobby-join",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-join", {lobby: $(this).data("info")._id, team: $(this).data("team") === undefined ? 'random' : $(this).data("team")});
    });

    $(document).on("click", ".lobby-leave",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-leave", {lobby: $(this).data("info")._id});
    });

    $(document).on("click", ".lobby-cancel",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-destroy", {lobby: $(this).data("info")._id});
    });

    $(document).on("click", ".lobby-take-slot",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        if(_user.inLobby && _user.lobbyInfo._id == $(this).data("info")._id)
        {
            ioSocket.socket.emit("lobby-player-set-team", {lobby: $(this).data("info")._id, team: $(this).data("team")});
        }
        else if(!_user.inLobby)
        {
            ioSocket.socket.emit("lobby-join", {lobby: $(this).data("info")._id, team: $(this).data("team")});
        }
        
    });

    $(document).on("click", ".lobby-change-team",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        if(_user.inLobby && _user.lobbyInfo._id == $(this).data("info")._id)
        {
            let xteam = _user.lobbyInfo.players[_user.me.steamid].team == 'A' ? 'B' : 'A';
            ioSocket.socket.emit("lobby-player-set-team", {lobby: $(this).data("info")._id, team: xteam});
        }       
        
    });


    $(document).on("click", ".lobby-host-kick-player",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        ioSocket.socket.emit("lobby-host-kick-player", {lobby: $(this).data("info")._id, player: $(this).data("player")});
    });

    $(document).on("click", ".lobby-host-ban-player",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;    
        ioSocket.socket.emit("lobby-host-ban-player", {lobby: $(this).data("info")._id, player: $(this).data("player")});
    });

    $(document).on("click", ".lobby-host-change-team",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;

        let xteam = $(this).data("player").team == 'A' ? 'B' : 'A';
        console.log("Host changing", $(this).data("player").steamid, "to TEAM", xteam);
        ioSocket.socket.emit("lobby-host-change-player-team", {lobby: $(this).data("info")._id, team: xteam, player: $(this).data("player")});
        
    });

    $(document).on("click", ".lobby-prev-map",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
                
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {maps: 'prev-map'}});
        
    });

    $(document).on("click", ".lobby-next-map",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
                
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {maps: 'next-map'}});
        
    });
    
    $(document).on("change", "#lobby-knife-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {knife: bool}});
        
    });

    $(document).on("change", "#lobby-ot-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {ot: bool}});
        
    });

    $(document).on("change", "#lobby-ff-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {ff: bool}});
        
    });

    $(document).on("change", "#lobby-eq-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {eq: bool}});
        
    });

    $(document).on("click", ".lobby-player-ready",async function() {   
        if(!_user.authed) return;        
                
        ioSocket.socket.emit("lobby-player-ready", {lobby: $(this).data("info")._id});
        
    });

    $(document).on("click", ".lobby-host-start",async function() {   
        if(!_user.authed) return;        
                
        ioSocket.socket.emit("lobby-host-go", {lobby: $(this).data("info")._id});
        
    });


    $(document).on("shown.bs.tab", "span.score-pill[data-bs-toggle=pill]", function (e) {
    
        //console.log("pill show");
        $($.fn.dataTable.tables(true)).DataTable()
        .columns.adjust()
        .scroller.measure();

    });
});



/**
 * 
 * SOCKET.IO PROCESSES
 * 
 */


const matchSocket = (socket) => {
    
    socket.on("sv_update", async (data) => {
        
        //console.log(data.sv);
        if(router.getCurrentLocation().url.includes(data.sv.server)) updateLobby(data.sv);
        
    });

    socket.on("player-join-lobby", async (data) => {
        //console.log("Player join lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);
    });

    socket.on("player-leave-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);        
    });

    socket.on("player-kick-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(data.player.steamid === _user.me.steamid)
        {
            errorMsg({title: "Ooops!", content: "You have been kicked from the lobby"});
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);        
    });

    socket.on("player-ban-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(data.player.steamid === _user.me.steamid)
        {
            errorMsg({title: "Ooops!", content: "You have been banned from the lobby"});
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);
    });

    socket.on("player-change-team", async (data) => {
        //console.log("Player", data.player, "changed to side", data.team);
        if(_user.lobbyInfo._id === data.lobby._id)
        {
            _user.lobbyInfo.players[_user.me.steamid].team = data.lobby.players[_user.me.steamid].team;
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            $("[data-pmenu=true]").remove(); //p menus de lobbies
            renderTeams(data.lobby);
        } 
        
    });

    socket.on("player-change-info", async (data) => {
        //console.log("Player", data.player, "changed to side", data.team);
        if(_user.lobbyInfo._id === data.lobby._id)
        {
            _user.lobbyInfo.players[_user.me.steamid] = data.lobby.players[_user.me.steamid];
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            $("[data-pmenu=true]").remove(); //p menus de lobbies
            renderTeams(data.lobby);
            renderFeatures(data.lobby);
        } 
        
    });

    socket.on("lobby-closed", async (data) => {

        if(_user.authed){
            _user.inLobby = false;
            _user.lobbyInfo = {};
            
        }
        if(data.creator === _user.me.steamid){
            errorMsg({title: "Ooops!", content: "The lobby has been removed"});
        }
        else
        {            
            errorMsg({title: "Ooops!", content: "The host has removed the game lobby"});
        }
        
        if(router.getCurrentLocation().url.includes(data._id))
        {
            console.log("lobby closed");
            $("#lobby-list-empty").addClass("d-none"); //bug?
            router.navigate("play");
        }

        
    });

    socket.on("lobby-destroyed", async (data) => {
        if(router.getCurrentLocation().url.includes(data.lobby._id) && !(_user.authed && data.lobby.players.hasOwnProperty(_user.me.steamid)))
        {            
            errorMsg({title: "Ooops!", content: "The host has removed the game lobby"});
            console.log("lobby destroyed");
            router.navigate("play");
        }
    });

    socket.on("lobby-update-settings", async (data) => {

        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            console.log("lobby new settings");
            renderFeatures(data.lobby);
        }

    });


    socket.on("lobby-preparing", async (data) => {

        errorMsg({title: "Yeah!", content: "Game is preparing"});
        console.log("lobby preparing");

    });

    socket.on("lobby-ongoing", async (data) => {

        errorMsg({title: "Yeah!", content: "Game is ongoing"});
        console.log("lobby ongoing");

    });

};

export {matchSocket};


/**
 * 
 * RENDER FUNCTIONS
 * 
 */

export function renderLobby(data){
    //console.log(data);
    /*renderLobbyButtons(data);
    
    $("#lobby-title").text(data.title);
    $("#lobby-badge-type").addClass(data.type == "scrim" ? "badge-light-info" : "badge-light-success").text(data.type);
    $(".lobby-vs").text(data.vs);
    $("#lobby-map-img").attr("src", `assets/media/maps/1080px/${data.maps[0]}.jpg`);
    $(".lobby-team-A-name").text(data.teamAname || "TEAM_A");
    $(".lobby-team-B-name").text(data.teamBname || "TEAM_B");
    
    let rn = 2//Math.floor(Math.random() * 3)
    $("#lobby-logo-teamA").attr("src", `assets/media/logos/${rn}_teamA.png`);
    $("#lobby-logo-teamB").attr("src", `assets/media/logos/${rn}_teamB.png`);

    
    $("#lobby-share-url").text(`${window.location}`);
    
    renderFeatures(data);
    renderTeams(data);

    router.updatePageLinks();*/
    $(".lobby-explicit").find("#lobby-title").text(data.tag);
    $(".lobby-explicit").find("#lobby-ongoing").text(data.live ? "LIVE" : "NO LIVE").addClass(data.live ? "border-success text-success" : "border-gray-700 text-gray-700");
    
    
    $(".lobby-explicit").find(".lobby-team-A-name").text(data.teamA_name || "TEAM_A");
    $(".lobby-explicit").find(".lobby-team-B-name").text(data.teamB_name || "TEAM_B");

    $(".lobby-explicit").find("#lobby-logo-teamA").attr("src", `assets/media/logos/2_teamA.png`);
    $(".lobby-explicit").find("#lobby-logo-teamB").attr("src", `assets/media/logos/2_teamB.png`);
    
    $(".lobby-explicit").find(".lobby-scorea").addClass(data.scoreA > data.scoreB ? 'text-primary' : 'text-gray-800').text(data.scoreA);
    $(".lobby-explicit").find(".lobby-scoreb").addClass(data.scoreA < data.scoreB ? 'text-primary' : 'text-gray-800').text(data.scoreB);

    $(".lobby-explicit").find(".lobby-region").html(`${data.region} <img class="ms-1" src="assets/media/flags/${data.flag}.gif">`);
    $(".lobby-explicit").find(".lobby-status").attr("data-i18n","play."+states[data.state]);

    $(".lobby-explicit").find(".lobby-server-btn").attr("data-clipboard-text","connect "+data.server);
    $(".lobby-explicit").find("#lobby-serverip").text(data.server);


    renderTeams(data);
    renderMiddleData(data);
    renderLobbyButtons(data);

    renderScoreBoards(data);
    
    $(".lobby-explicit").localize();
    $(".lobby-explicit").find('[data-toggle="tooltip"]').tooltip();
    
}

function updateLobby(data){

    //lobby header
    if(data.live !== undefined) $(".lobby-explicit").find("#lobby-ongoing").text(data.live ? "LIVE" : "NO LIVE").removeClass(!data.live ? "border-success text-success" : "border-gray-700 text-gray-700").addClass(data.live ? "border-success text-success" : "border-gray-700 text-gray-700");
    
    if(data.scoreA !== undefined && data.scoreB !== undefined)
    {
        $(".lobby-explicit").find(".lobby-scorea").removeClass('text-primary').removeClass('text-gray-800');
        $(".lobby-explicit").find(".lobby-scoreb").removeClass('text-primary').removeClass('text-gray-800');
        $(".lobby-explicit").find(".lobby-scorea").addClass(data.scoreA > data.scoreB ? 'text-primary' : 'text-gray-800').text(data.scoreA);
        $(".lobby-explicit").find(".lobby-scoreb").addClass(data.scoreA < data.scoreB ? 'text-primary' : 'text-gray-800').text(data.scoreB);
    }

    if(data.teamA_name !== undefined && data.teamB_name !== undefined)
    {
        if($(".lobby-explicit").find(".lobby-team-A-name").text() != data.teamA_name && data.teamA_name != "") $(".lobby-explicit").find(".lobby-team-A-name").text(data.teamA_name || "TEAM_A");

        if($(".lobby-explicit").find(".lobby-team-B-name").text() != data.teamB_name && data.teamB_name != "") $(".lobby-explicit").find(".lobby-team-B-name").text(data.teamB_name || "TEAM_B");        
    }

    //middledata
    if(data.map !== undefined && data.map != $(".lobby-explicit").find('.lobby-map-name').text())
    {
        renderMiddleData(data);
    }

    $(".lobby-explicit").find(".lobby-status").attr("data-i18n","play."+states[data.state]);
    
    $(".lobby-explicit").localize();


    //players
    if(data.players !== undefined)
    {
        renderTeams(data, 1);
        renderScoreBoards(data, 1);
    }    
    


}

export function renderScoreBoards(data, update = 0){

    if(update) console.log("Updating Scoreboards");

    let datasetA = [];
    let datasetB = [];

    let dataset = {};

    Object.keys(data.players).forEach(function(key, index) {
        if(data.players[key].team > 0 && data.players[key].team < 3)
        {
            if(data.stats[key] !== undefined && data.users[key] !== undefined)
            {
                let datatmp = [];
                
                datatmp.push({steamid: key, avatar: data.users[key].avatar, communityid: data.users[key].communityid, nickname: data.players[key].nickname, country: data.stats[key].country, city: data.stats[key].city, flag: data.stats[key].flag.toLowerCase()});

                datatmp.push({rating: data.stats[key].rating, rd: data.stats[key].rd});
                datatmp.push(data.stats[key].rating);
                datatmp.push(data.players[key].kills);
                datatmp.push(data.players[key].hs);
                datatmp.push(data.players[key].deaths);
                datatmp.push(data.players[key].assists);
                datatmp.push((data.players[key].kills/(data.players[key].deaths == 0 ? 1 : data.players[key].deaths)).toFixed(2));
                datatmp.push((data.players[key].assists/(data.players[key].rounds == 0 ? 1 : data.players[key].rounds)).toFixed(2));
                datatmp.push((data.players[key].damage/(data.players[key].rounds == 0 ? 1 : data.players[key].rounds)).toFixed(2));

                if(data.players[key].realteam == "A")
                {
                    datasetA.push(datatmp);
                    dataset[key] = datatmp;
                }

                if(data.players[key].realteam == "B")
                {
                    datasetB.push(datatmp);
                    dataset[key] = datatmp;
                }

                

            }
        }
    });

    //if(scoreBoardA != null) scoreBoardA.destroy();
    //if(scoreBoardB != null) scoreBoardB.destroy();
    if(update)
    {
        let arrUpd = [];

        if(data.players !== undefined && Object.keys(data.players).length > 0)
        {
            Object.keys(data.players).forEach(function(key, index) {
                if(data.players[key].team > 0 && data.players[key].team < 3)
                {
                    arrUpd.push(key);                
                }
            });
        }


        let arrPl = [];
        $(".player-row").each(function() {
            arrPl.push($(this).attr("data-steamid"));
            if(!arrUpd.includes($(this).attr("data-steamid")))
            {
                //$(this).remove();
                console.log("Remove ",$(this).attr("data-steamid"));
                if(scoreBoardA != null) scoreBoardA.row($(this)).remove().draw(false);
                if(scoreBoardB != null) scoreBoardB.row($(this)).remove().draw(false);
                
            }
        });

    }

    if(update)
    {
        Object.keys(data.players).forEach(function(key, index) {
            if(!$(`.player-row[data-steamid="${key}"]`).length)
            {
                //console.log($(`.player-row[data-steamid="${key}"]`).length);
                if(data.players[key].realteam == 'A')
                {
                    scoreBoardA.row.add(dataset[key]).draw(false);
                }
                if(data.players[key].realteam == 'B')
                {
                    scoreBoardB.row.add(dataset[key]).draw(false);
                }
            }
            else
            {
                if(data.players[key].realteam == 'A')
                {
                    scoreBoardA.row($(`.player-row[data-steamid="${key}"]`)).data(dataset[key]).draw(false);
                }
                if(data.players[key].realteam == 'B')
                {
                    scoreBoardB.row($(`.player-row[data-steamid="${key}"]`)).data(dataset[key]).draw(false);
                }
            }
        });
    }
    else
    {
        scoreBoardA = $("#scoreboard-A").DataTable({
            //scrollY:        "300px",
            scrollX:        true,
            sScrollXInner: "100%",
            scrollCollapse: true,    
            "bPaginate": false,
            "bFilter": false,
            "bInfo": false,
            language: {
                emptyTable: "",
                loadingRecords: "",
                zeroRecords: ""
            },
            fixedColumns:   {
                left: 1
            },
            data: datasetA,
            "columnDefs": [ 
                {
                    orderable: false,
                    "target": 0,                
                    "render": function ( data, type, row, meta ) {
                        return `<div class="d-flex flex-row flex-nowrap"><span class="d-flex align-self-center me-2" title="${data.city} ${data.country}" data-toggle="tooltip"><img class="w-20px" src="assets/media/flags/${data.flag}.gif"></span> <a href="user/${data.communityid}" href="_blank" class="text-gray-700 text-hover-white fs-7 lh-2 text-nowrap text-truncate mw-150px mw-md-auto">${data.nickname === undefined ? data.steamid.replace("BOT:", "") : sanitizeHTML(data.nickname)}</a></div>`;
                    }
                },
                {
                    orderable: false,
                    "target": 1,                
                    "render": function ( data, type, row, meta ) {
                        return `<div class="symbol symbol-25px" data-toggle="tooltip" title="${getEloLevel(data.rating, data.rd)} Stars">
                        <img alt="Pic" src="assets/media/ranks/rank_${getEloLevel(data.rating, data.rd)}.png">
                        </div> `;
                    }
                }
            ],
            createdRow: function (row, data, index) {
                //console.log(row);
                //console.log(data);
                $(row).addClass(`player-row`).attr("data-steamid", data[0].steamid);
            },
            order: [[3, 'desc']]
        });
    
        scoreBoardB = $("#scoreboard-B").DataTable({
            //scrollY:        "300px",
            scrollX:        true,
            sScrollXInner: "100%",
            scrollCollapse: true,    
            "bPaginate": false,
            "bFilter": false,
            "bInfo": false,
            language: {
                emptyTable: "",
                loadingRecords: "",
                zeroRecords: ""
            },
            fixedColumns:   {
                left: 1
            },
            data: datasetB,
            "columnDefs": [ 
                {
                    orderable: false,
                    "target": 0,                
                    "render": function ( data, type, row, meta ) {
                        return `<div class="d-flex flex-row flex-nowrap"><span class="d-flex align-self-center me-2" title="${data.city} ${data.country}" data-toggle="tooltip"><img class="w-20px" src="assets/media/flags/${data.flag}.gif"></span> <a href="user/${data.communityid}" href="_blank" class="text-gray-700 text-hover-white fs-7 lh-2 text-nowrap text-truncate mw-150px mw-md-auto">${data.nickname === undefined ? data.steamid.replace("BOT:", "") : sanitizeHTML(data.nickname)}</a></div>`;
                    }
                },
                {
                    orderable: false,
                    "target": 1,                
                    "render": function ( data, type, row, meta ) {
                        return `<div class="symbol symbol-25px" data-toggle="tooltip" title="${getEloLevel(data.rating, data.rd)} Stars">
                        <img alt="Pic" src="assets/media/ranks/rank_${getEloLevel(data.rating, data.rd)}.png">
                        </div> `;
                    }
                }
            ],
            createdRow: function (row, data, index) {
                //console.log(row);
                //console.log(data);
                $(row).addClass(`player-row`).attr("data-steamid", data[0].steamid);
            },
            order: [[3, 'desc']]
        });
    }

    $("#scoreboard-A").find('[data-toggle="tooltip"]').tooltip();
    $("#scoreboard-B").find('[data-toggle="tooltip"]').tooltip();
    
}

export function renderTeams(data, update = 0){
    
    if(data.players === undefined) return;
    let teamA = []; 
    let teamB = [];   
    
    let winchance = {A: 0, B: 0};
    let Anum = 0;
    let Bnum = 0;

    Object.keys(data.players).forEach(function(key, index) {
        if(data.stats[key] !== undefined)
        {
            if(data.players[key].realteam == 'A') 
            {
                teamA.push(renderPlayer(key, data));
                winchance.A += data.stats[key].matches_win/(data.stats[key].matches == 0 ? 1 : data.stats[key].matches);
                Anum++;
            }
            if(data.players[key].realteam == 'B') 
            {
                teamB.push(renderPlayer(key, data));
                winchance.B += data.stats[key].matches_win/(data.stats[key].matches == 0 ? 1 : data.stats[key].matches);
                Bnum++;
            }
        }
    });

    winchance.A = (winchance.A/(!Anum ? 1 : Anum)).toFixed(2);
    winchance.B = (winchance.B/(!Bnum ? 1 : Bnum)).toFixed(2);

    //console.log(winchance);

    let wc = getWinChance(winchance.A, winchance.B);
    $(".lobby-explicit").find(".lobby-wcA").css("width", `${wc.chanceA.toFixed(2)}%`).attr("title", `${wc.chanceA.toFixed(2)}%`);
    $(".lobby-explicit").find(".lobby-wcB").css("width", `${wc.chanceB.toFixed(2)}%`).attr("title", `${wc.chanceB.toFixed(2)}%`);


    if(update)
    {
        let arrUpd = [];

        if(data.players !== undefined && Object.keys(data.players).length > 0)
        {
            Object.keys(data.players).forEach(function(key, index) {
                if(data.players[key].team > 0 && data.players[key].team < 3)
                {
                    arrUpd.push(key);                
                }
            });
        }


        let arrPl = [];
        $(".player-slot").each(function() {
            arrPl.push($(this).attr("data-steamid"));
            if(!arrUpd.includes($(this).attr("data-steamid")))
            {
                $(this).remove();
            }
        });

    }
   
    if(teamA.length)
    { 
        $(".lobby-noplayersA").remove();
        if(update == 0)
        {
            $(".lobby-explicit").find(".teamAlist").html("").append(teamA);
        }
        else
        {
            teamA.map(pla => {            
                if(!$(`.player-slot[data-steamid="${pla.data("steamid")}"]`).length)
                {
                    $(".lobby-explicit").find(".teamAlist").append(pla);
                }
            });
        }
        
    }
    else
    {
        $(".lobby-explicit").find(".teamAlist").html(`<div class="card">
            <div class="lobby-noplayersA text-center">
                <!--begin::Icon-->
                <div class="pt-15 pb-6">
                    <i class="fad fa-helmet-battle fs-3x text-primary opacity-75"></i>
                </div>
                <!--end::Icon-->
                <!--begin::Message-->
                <div class="fw-bold pb-15">
                    <h3 class="text-gray-600 fs-5 mb-2">No players in this team</h3>
                    <div class="text-muted fs-7">Invite some friends and let's play</div>
                </div>
                <!--end::Message-->
            </div>
        </div>`);
    }

    if(teamB.length)
    {
        $(".lobby-noplayersB").remove();
        if(update == 0)
        {
            $(".lobby-explicit").find(".teamBlist").html("").append(teamB);
        }
        else
        {
            teamB.map(pla => {            
                if(!$(`.player-slot[data-steamid="${pla.data("steamid")}"]`).length)
                {
                    $(".lobby-explicit").find(".teamBlist").append(pla);
                }
            });
        }
    }
    else
    {
        $(".lobby-explicit").find(".teamBlist").html(`<div class="card">
            <div class="lobby-noplayersB text-center">
                <!--begin::Icon-->
                <div class="pt-15 pb-6">
                    <i class="fad fa-helmet-battle fs-3x text-primary opacity-75"></i>
                </div>
                <!--end::Icon-->
                <!--begin::Message-->
                <div class="fw-bold pb-15">
                    <h3 class="text-gray-600 fs-5 mb-2">No players in this team</h3>
                    <div class="text-muted fs-7">Invite some friends and let's play</div>
                </div>
                <!--end::Message-->
            </div>
        </div>`);
    }
       
    router.updatePageLinks();
    KTMenu.createInstances(`[data-pmenu="true"]`);
}

export function renderPlayer(steamid, lobby = {}){

    if(lobby.users[steamid] === undefined) 
    {
        console.log(steamid);
        let r = ``;
        r = $(r);
        return r;
    }

    let html = /* html */`

        <div class="card mb-4 player-slot" data-steamid="${steamid}">
            <div class="card-body p-5">
                <div class="d-flex flex-stack">
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-3">                                                   
                            <img src="${lobby.users[steamid].avatar === undefined ? "assets/media/avatars/default.jpg" : lobby.users[steamid].avatar}" class="" alt="">
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <a href="user/${lobby.users[steamid].communityid}" href="_blank" class="text-gray-700 fw-bolder text-hover-white fs-6 lh-2 text-nowrap text-truncate mw-150px mw-md-auto">${lobby.users[steamid].nickname === undefined ? lobby.users[steamid].steamid.replace("BOT:", "") : sanitizeHTML(lobby.users[steamid].nickname)}</a>
                            <div class="d-flex flex-row gap-2 lh-3 text-gray-600 fw-bold fs-6">
                                
                                <div class="d-flex align-self-center" title="${lobby.stats[steamid].city} ${lobby.stats[steamid].country}" data-toggle="tooltip">
                                    <img class="w-20px" src="assets/media/flags/${lobby.stats[steamid].flag.toLowerCase()}.gif">
                                </div>
                                <div class="d-flex align-self-center" title="${lobby.users[steamid].steamid}" data-toggle="tooltip">
                                    <a class="text-hover-white lh-1" href="https://steamcommunity.com/profiles/${lobby.users[steamid].communityid}/" target="_blank">
                                        <i class="fab fa-steam fs-4"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                    <span class="badge fw-bold text-white fs-7" style="background-color: #151515;" data-toggle="tooltip" title="ELO">${lobby.stats[steamid].rating}</span>
                        <div class="symbol symbol-40px ms-2" data-toggle="tooltip" title="${getEloLevel(lobby.stats[steamid].rating, lobby.stats[steamid].rd)} stars">
                            <img alt="Pic" src="assets/media/ranks/rank_${getEloLevel(lobby.stats[steamid].rating, lobby.stats[steamid].rd)}.png">
                        </div>                                
                    </div>
                </div>
            </div>
            <div class="card-footer px-5 py-4 d-flex justify-content-between gap-4">                        
                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Matches won percentage">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-swords fs-2 text-success"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(lobby.stats[steamid].matches_win/(lobby.stats[steamid].matches == 0 ? 1 : lobby.stats[steamid].matches)*100).toFixed(0)}%</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1 text-nowrap">Win Rate</div>
                    </div>
                    <!--end::Title-->
                </div>

                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Kills per Death ratio">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-skull fs-2 text-info"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(lobby.stats[steamid].kills/(lobby.stats[steamid].deaths == 0 ? 1 : lobby.stats[steamid].deaths)).toFixed(2)}</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1">KDR</div>
                    </div>
                    <!--end::Title-->                    
                </div>

                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Average Damage per Round">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-meteor fs-2 text-primary"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(lobby.stats[steamid].damage/(lobby.stats[steamid].rounds == 0 ? 1 : lobby.stats[steamid].rounds)).toFixed(2)}</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1">ADR</div>
                    </div>
                    <!--end::Title-->                    
                </div>
            </div>
        </div>

    `;

    html = $(html);
    
    html.data("steamid",steamid);

    router.updatePageLinks();

    return html;
}

export function renderMiddleData(data) {

    $(".lobby-explicit").find('.lobby-map-img').attr("src", `assets/media/maps/400px/${data.map}.jpg`);
    $(".lobby-explicit").find('.lobby-map-name').text(data.map);
    $(".lobby-explicit").find('.lobby-map-bg').css("background-image", `url('assets/media/maps/400px/${data.map}.jpg')`)
    router.updatePageLinks();
}






export function renderLobbyButtons(data){

    let btn_hltv = `<div class="btn-group" role="group">
            <a href="steam://connect/${data.hltv}" target="_blank" class="btn border border-info btn-active-color-white px-4 btn-color-muted text-nowrap lobby-btn-hltv lobby-live external-handler"><i class="fal fa-tv fs-5"></i>
                HLTV
            </a>
            <button type="button" class="btn btn-lg btn-active-primary btn-info btn-color-zblack btn-active-color-white btn-icon clip" data-clipboard-text="connect ${data.hltv}" data-bs-toggle="popover" data-bs-content="Copied IP to clipboard" data-bs-trigger="manual" data-bs-placement="top">
                <i class="fal fa-copy fs-4"></i>
            </button>
        </div>`;
    
    let btn_connect = `<div class="btn-group" role="group">
                    <a href="steam://connect/${data.server}" target="_blank" class="btn border border-primary btn-active-color-white px-4 btn-color-gray-800 text-nowrap lobby-btn-connect  external-handler"><i class="fad fa-portal-enter fs-3"></i> <span data-i18n="play.connect">Join</span></a>
                    <button type="button" class="btn btn-lg btn-primary btn-color-zblack btn-active-color-white btn-icon clip" data-clipboard-text="${data.server} data-bs-toggle="popover" data-bs-content="Copied IP to clipboard" data-bs-trigger="manual" data-bs-placement="top">
                       <i class="fal fa-copy fs-4"></i>
                    </button>
                </div>`;

    btn_hltv = $(btn_hltv);
    btn_connect = $(btn_connect);    

    $(".lobby-explicit").find(".lobby-buttons").append([btn_hltv,btn_connect]).localize();
    
    router.updatePageLinks();
}

export function renderFeatures(data) {

    let host = _user.me.steamid === data.creator ? true : false;
    let authed = _user.authed ? true : false;
    let imIn = data.players.hasOwnProperty(_user.me.steamid) ? true : false;
                    
    let ready = `<button type="button" class="mt-4 mb-2 btn btn-outline btn-outline-success w-100 bg-success bg-state-opacity-0 text-hover-success text-black lobby-player-ready">Ready</button>`;
    let start = `<button type="button" class="mt-4 mb-2 btn btn-outline btn-outline-primary w-100 bg-primary bg-state-opacity-0 text-hover-primary text-black lobby-host-start">Start</button>`;
    let btn = ``;

    if(authed)
    {
        //if(imIn) btn = host ? start : ready;
        if(imIn)
        {
            if(host)
            {
                btn = start;
            }
            else
            {
                if(!data.players[_user.me.steamid].ready)
                {
                    btn = ready;
                }
            }
        }
    }    

    $("#lobby-features-map-img").css("background-image", `url('assets/media/maps/400px/${data.maps[0]}.jpg')`);
    
    if(host){
        $("#lobby-map-ctrl").html(`
            <span class="btn btn-sm h-100 btn-icon bg-state-opacity-50 bg-state-light lobby-prev-map" style="position:absolute;left:0;top:50%;cursor: pointer;transform: translateY(-50%);"><i class="bi bi-caret-left fs-2 text-primary"></i></span>
            <span class="btn btn-sm h-100 btn-icon bg-state-opacity-50 bg-state-light lobby-next-map" style="position:absolute;right:0;top:50%;cursor: pointer;transform: translateY(-50%);"><i class="bi bi-caret-right fs-2 text-primary"></i></span>
        `);
    }

    $("#lobby-features-container").html(/*html*/`
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Map</div>
            <div id="lobby-features-map" class="fs-8 text-gray-900">${data.maps[0]}</div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Location</div>
            <div id="lobby-features-location" class="fs-8 text-gray-900">${data.region}</div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Ping</div>
            <div class="">
                <span class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="bi bi-bar-chart-fill text-success fs-8"></i> <span id="lobby-features-ping" data-showping="${data.location}">${_user.ping !== undefined ? (_user.ping[data.location] || 0) : 0}</span> <span>ms</span></span>
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Knife Round</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-knife-switch" ${data.knife ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-knife" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.knife ? 'on':'off'} text-primary fs-5 ${data.knife ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Overtime</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-ot-switch" ${data.ot ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-ot" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.ot ? 'on':'off'} text-primary fs-5 ${data.ot ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Friendly Fire</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-ff-switch" ${data.ff ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-ff" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.ff ? 'on':'off'} text-primary fs-5 ${data.ff ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Show Equip</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-eq-switch" ${data.eq ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-eq" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.eq ? 'on':'off'} text-primary fs-5 ${data.eq ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>

        ${btn}
    `);

    $("#lobby-map-ctrl").find('.lobby-prev-map').data("info", data);
    $("#lobby-map-ctrl").find('.lobby-next-map').data("info", data);
    $("#lobby-knife-switch").data("info", data);
    $("#lobby-ot-switch").data("info", data);
    $("#lobby-ff-switch").data("info", data);
    $("#lobby-eq-switch").data("info", data);    
    $("#lobby-features-container").find("button").data("info",data);
    router.updatePageLinks();
}

/*export function renderTeams(data){
    
    let teamA = []; 
    let teamB = [];

    data.teamA.map(steamid => {       
        teamA.push(renderPlayer(data.players[steamid], "A", steamid === data.creator ? true : false, data));
    });

    data.teamB.map(steamid => {        
        teamB.push(renderPlayer(data.players[steamid], "B", steamid === data.creator ? true : false, data));
    });

    if(teamA.length < parseInt(data.vs))
    {
        let num = parseInt(data.vs) - teamA.length - (teamB.length > parseInt(data.vs) ? (teamB.length - parseInt(data.vs)) : 0);
        for(let i = 0; i < num; i++)
        {
            teamA.push(renderSlot(data,"A"));
        }
    }

    if(teamB.length < parseInt(data.vs))
    {
        let num = parseInt(data.vs) - teamB.length - (teamA.length > parseInt(data.vs) ? (teamA.length - parseInt(data.vs)) : 0);
        for(let i = 0; i < num; i++)
        {
            teamB.push(renderSlot(data,"B"));
        }
    }

    console.log("teamA: ", teamA);
    console.log("teamB: ", teamB);

    $(".team-A-container").html("").append(teamA);
    $(".team-B-container").html("").append(teamB);
   
    router.updatePageLinks();
    KTMenu.createInstances(`[data-pmenu="true"]`);
}*/

/*export function renderPlayer(data, team, isCreator = false, lobby = {}){

    //console.log("rendering player", data);

    let host = _user.me.steamid === lobby.creator ? true : false;
    let authed = _user.authed ? true : false;
    let imIn = lobby.players.hasOwnProperty(_user.me.steamid) ? true : false;
        
    let me =  data.steamid === _user.me.steamid ? true : false;
    let crown = `<span class="badge badge-sm badge-secondary text-gray-100"><i class="fas fa-crown text-zyellow"></i></span>`;
    let ready = `<span class="badge badge-sm badge-success text-gray-100"><i class="bi bi-check-circle me-1"></i>Ready</span>`;
    let waiting = `<span class="d-flex align-items-center badge badge-sm badge-secondary text-success"><span class="spinner-border spinner-border-sm me-2" style="width: 0.9rem;height: 0.9rem;"></span>Waiting</span>`;

    let btn_player_menu = `<button class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end h-auto w-auto" data-kt-menu-trigger="click" data-kt-menu-placement="${team == 'B' ? 'bottom-end' : 'bottom-start'}" data-kt-menu-overflow="true">    
        <span class="svg-icon svg-icon-1 svg-icon-gray-300  ${team == 'A' ? 'me-n1' : 'ms-n1'}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                <rect x="11" y="11" width="2" height="2" rx="1" fill="currentColor"/>
                <rect x="11" y="15" width="2" height="2" rx="1" fill="currentColor"/>
                <rect x="11" y="7" width="2" height="2" rx="1" fill="currentColor"/>
            </svg>
        </span>    
    </button>
    <div id="lobby-pmenu-${data._id}" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-pmenu-${data._id}="true" data-kt-menu="true" data-pmenu="true" style="">
        <!--begin::Heading-->
        <div class="menu-item px-3">
            <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Actions</div>
        </div>
        <!--end::Heading-->
        
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-kick-player">Kick Player
            <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-ban-player">Ban Player
            <i class="fas fa-ban ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-change-team">Change Team
            <i class="fas fa-exchange-alt ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        
    </div>
    `;

    let state = ``;
    let pmenu = ``;

    if(isCreator)
    {
        state = crown;
    }
    else{
        if(data.ready == true)
        {
            state = ready;
        }
        else
        {
            state = waiting;
        }
    }

    if(host)
    {
        pmenu = isCreator ? "" : btn_player_menu;
    }
    
    let html =  `
    <div class="card ${me ? '' : "card-bordered"} bg-transparent mb-3" ${me ? `style="box-shadow: none;border: 1px solid rgb(255 143 0 / 75%);"` : ""}>
        <div class="d-flex flex-stack ${team == 'B' ? 'flex-row-reverse' : ''} py-3 px-3">
            <!--begin::Details-->
            <div class="d-flex align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                <!--begin::Avatar-->
                <div class="symbol symbol-40px">
                    <img alt="Pic" src="${data.avatar}">                    
                </div>
                <!--end::Avatar-->
                <!--begin::Details-->
                <div class="${team == 'B' ? 'me-4' : 'ms-4'} mw-150px text-truncate text-nowrap ${team == 'B' ? 'text-end' : ''}">
                    <a href="user/${data.communityid}" data-navigo class="fs-7 text-gray-900 mb-2 text-truncate text-nowrap player-nick"></a>
                    <div class="fw-bold text-muted fs-7">
                        <div class="d-flex justify-content-start align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                            <div class="d-flex ${team == 'B' ? 'ms-2' : 'me-2'}">
                                <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white"><i class="fab fa-steam fs-3"></i></a>
                            </div>
                            <div class="symbol symbol-20px">
                                <img src="assets/media/roles/awper.png">
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::Details-->
            </div>
            <!--end::Details-->
            <!--begin::Lat seen-->
            <div class="d-flex flex-row align-items-center gap-2 ${team == 'A' ? "ms-2":"me-2"} ${team == 'B' ? "flex-row-reverse":""}">
                ${state}${pmenu}
            </div>
            <!--end::Lat seen-->
        </div>
    </div>    
    `;

    html = $(html);
    html.find(".player-nick").text(data.nickname);
    html.localize();    
    
    html.find(`#lobby-pmenu-${data._id}`);

    html.find(`.lobby-host-kick-player`).data("player", data);
    html.find(`.lobby-host-kick-player`).data("info", lobby);

    html.find(`.lobby-host-ban-player`).data("player", data);
    html.find(`.lobby-host-ban-player`).data("info", lobby);

    html.find(`.lobby-host-change-team`).data("player", data);
    html.find(`.lobby-host-change-team`).data("team", team);
    html.find(`.lobby-host-change-team`).data("info", lobby);
    

    router.updatePageLinks();

    return html;
}*/

export function renderSlot(data, team){
    //console.log(data);
    let html = /* html */ `<div class="card card-dashed bg-transparent mb-3 ${data.players.hasOwnProperty(_user.me.steamid) && data.players[_user.me.steamid].team == team ? '' : 'cursor-pointer lobby-take-slot'}">
                <div class="d-flex flex-stack ${team == 'B' ? 'flex-row-reverse' : ''} py-3 px-3">
                    <!--begin::Details-->
                    <div class="d-flex align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                        <!--begin::Avatar-->
                        <div class="symbol symbol-40px  align-self-center">
                            <i class="bi bi-plus-circle text-gray-300 fs-2tx"></i>
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Details-->
                        <div class="${team == 'B' ? 'me-4' : 'ms-4'} mw-150px text-truncate text-nowrap ${team == 'B' ? 'text-end' : ''}">
                            <span class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">${data.players.hasOwnProperty(_user.me.steamid) && data.players[_user.me.steamid].team == team ? 'Empty Slot' : 'Take Slot'}</span>
                            <div class="fw-bold text-muted fs-7"></div>    
                        </div>
                        <!--end::Details-->
                    </div>
                    <!--end::Details-->
                    <!--begin::Lat seen-->
                    <div class="d-flex flex-column align-items-end me-2">
                        <div class="symbol symbol-40px">                                                                
                        </div>                            
                    </div>
                    <!--end::Lat seen-->
                </div>
            </div>`;
    
    html = $(html);
    html.data("info",data);
    html.data("team",team);
    html.localize();

    router.updatePageLinks();

    return html;
    
}

const getWinChance = (a, b) => {
    const constanteElo = 0.4;
    const chanceA = 100 / (1 + Math.pow(10, ((b - a) / constanteElo)));
    const chanceB = 100 / (1 + Math.pow(10, ((a - b) / constanteElo)));
    return {chanceA,chanceB};
};

const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
};

var clip = new ClipboardJS('.btn-copy');
clip.on('success', function (e) {
    
    e.clearSelection();
    if($(e.trigger).hasClass("copy-done")) return;
    let back = $(e.trigger).html();
    let backclass = $(e.trigger).attr("class");
    backclass = backclass.split(/\s+/);    
    backclass.map(cl => {$(e.trigger).removeClass(cl)});

    let fuckclass = "btn btn-sm btn-copy copy-done btn-icon btn-success";
    fuckclass = fuckclass.split(/\s+/);
    fuckclass.map(cl => {$(e.trigger).addClass(cl)});
    $(e.trigger).html(`<i class="bi bi-check fs-2x text-black"></i>`);

    var El = e.trigger;
    var popover = new bootstrap.Popover(El, {content: "Copied!", trigger: "manual"});
    popover.show();

    setTimeout(() => {
        fuckclass.map(cl => {$(e.trigger).removeClass(cl)});
        backclass.map(cl => {$(e.trigger).addClass(cl)});
        $(e.trigger).html(back);        
        popover.dispose();
    }, 2000);

  });


function sanitizeHTML(html) {
const $temp = $("<div>");
$temp.html(html);
const sanitizedHTML = $temp.text();
return sanitizedHTML;
}



export default match;